<template>
  <div class="comp-ym-pdfimage" ref="pdfView">
    <div class="pdf-page" v-for="(page, index) in pages" :key="index">
      <canvas></canvas>
      <div class="text-layer"></div>
    </div>
  </div>
</template>

<script>
export default{
  name: 'pdf-image',
  props: ['url', 'password', 'scale'],
  data() {
    return {
      pages: [],
      running: false,
      needRefresh: false
    };
  },
  computed: {
    _scale() {
      return +(this.scale ? this.scale : 1.5);
    },
    _url() {
      return this.url ? this.url : '';
    },
    _password() {
      return this.password ? this.password : null;
    }
  },
  watch: {
    url: 'refresh',
    scale: 'refresh',
    password: 'refresh'
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    async refresh() {
      if (this.running) {
        this.needRefresh = true;
        return;
      }
      try {
        this.running = true;
        await this.initPdf({
          url: this._url,
          password: this._password,
          scale: this._scale
        });
      } finally {
        this.running = false;
        if (this.needRefresh) {
          this.needRefresh = false;
          await this.refresh();
        }
      }
    },

    buildSVG(viewport, textContent, pdfjsLib) {
      const SVG_NS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(SVG_NS, "svg:svg");
      svg.setAttribute("width", viewport.width + "px");
      svg.setAttribute("height", viewport.height + "px");
      svg.setAttribute("font-size", "1");
      svg.style.width = "100%";

      textContent.items.forEach(function (textItem) {
        const tx = pdfjsLib.Util.transform(
          pdfjsLib.Util.transform(viewport.transform, textItem.transform),
          [1, 0, 0, -1, 0, 0]
        );
        const style = textContent.styles[textItem.fontName];
        const text = document.createElementNS(SVG_NS, "svg:text");
        text.setAttribute("transform", "matrix(" + tx.join(" ") + ")");
        text.setAttribute("font-family", style.fontFamily);
        text.setAttribute("width", textItem.width);
        text.setAttribute("height", textItem.height);
        text.setAttribute("fill", "rgba(255,0,0,0)");
        text.textContent = textItem.str;
        svg.append(text);
      });

      return svg;
    },

    initPdf(src) {
      src.password = src.password || null;
      src.scale = src.scale || 1.5;
      if (!src.url) {
        this.pages = [];
        return;
      }

      const that = this;
      return new Promise((resolve, reject) => {
        (async () => {
          let pdfjsLib = window.pdfjsLib || globalThis.pdfjsLib;
          if (!pdfjsLib) {
            that.$message.error("初始化pdf组件出错");
            return;
          }
          pdfjsLib.GlobalWorkerOptions.workerSrc = "./js/pdf.worker.js";
          const loadingTask = pdfjsLib.getDocument(
            src,
            false,
            null,
            function (progress) {
              var percent_loaded = (progress.loaded / progress.total) * 100;
            }
          );

          let pdf = await loadingTask.promise;
          let total = pdf.numPages;
          that.pages = [];
          for (let i = 0; i < total; i++) {
            that.pages.push({ scale: src.scale });
          }

          that.$nextTick(() => {
            let pagePromises = [];
            let view = that.$refs.pdfView;
            for (let i = 0; i < total; i++) {
              let page = that.pages[i];
              let pageDiv = view.childNodes[i];
              let canvas = pageDiv.querySelector("canvas");
              let textLayout = pageDiv.querySelector(".text-layer");
              page.canvas = canvas;
              page.textLayout = textLayout;

              pagePromises.push(
                (async () => {
                  let pdfPage = await pdf.getPage(i + 1);
                  var viewport = pdfPage.getViewport({ scale: page.scale });

                  var context = canvas.getContext("2d");
                  canvas.height = viewport.height;
                  canvas.width = viewport.width;

                  var renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                  };
                  await pdfPage.render(renderContext).promise;

                  let textContent = await pdfPage.getTextContent();
                  const svg = that.buildSVG(viewport, textContent, pdfjsLib);
                  textLayout.append(svg);
                  pdfPage.cleanup();
                })()
              );
            }

            Promise.all(pagePromises)
              .then(res => resolve(res))
              .catch(err => reject(err));
          });
        })().catch(err => reject(err));
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-ym-pdfimage::v-deep {
  .pdf-page {
    margin-bottom: 10px;
    // border: solid 1px #888;
    width: fit-content;
    position: relative;

    canvas {
      // border: 1px solid black;
      direction: ltr;
      width: 100%;
    }
    .text-layer {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
      opacity: 1;
    }
  }
}
</style>

